const dict = {
  languageName: '繁體中文 (台灣)',
  locale: 'zh-TW',
  fallback: 'en',
  dir: 'ltr',

  // app
  'app.name': 'Kavykhi.Cloud',
  'app.title': (sub) => `${sub} - Kavykhi.Cloud`,

  // themes
  theme: '佈景主題',
  'theme.light': '淺色',
  'theme.dark': '深色',
  'theme.system': '系統預設',
  'theme.sakura': '櫻花',

  // generic
  email: '電子郵件',
  password: '密碼',
  ok: '確定',
  cancel: '取消',
  retry: '重試',
  copy: '複製',
  empty: '(無項目)',
  loading: '載入中...',
  calculating: '計算中...',
  error: '錯誤',

  'in_development': '此頁面正在開發中。',

  // errors
  'error.not_found': '找不到',
  'error.name_conflict': '名稱衝突',
  'error.bad_param': '參數錯誤',
  'error.wrong_auth': '驗證錯誤',
  'error.unauthorized': '未授權',
  'error.wrong_credentials': '憑證錯誤',
  'error.wrong_provider': '提供商錯誤',
  'error.insufficient_privileges': '權限不足',
  'error.not_empty': '非空',
  'error.limit_exceeded': '超出限制',
  'error.already_member': '已是成員',
  'error.not_finalized': '未完成',
  'error.already_finalized': '已完成',
  'error.unexpected_patch': '非預期的修補檔',
  'error.timeout': '逾時',
  'error.not_patch': '非修補檔',
  'error.not_supported': '不支援',
  'error.unexpected_error': '未預期的錯誤',

  // data sizes
  'datasize.B': 'B',
  'datasize.KiB': 'KiB',
  'datasize.MiB': 'MiB',
  'datasize.GiB': 'GiB',
  'datasize.TiB': 'TiB',

  // auth providers
  'auth.provider.steam': 'Steam',
  'auth.provider.github': 'GitHub',
  'auth.provider.gitlab': 'GitLab',
  'auth.provider.itch': 'itch.io',
  'auth.provider.twitch': 'Twitch',
  'auth.provider.discord': 'Discord',
  'auth.provider.google': 'Google',

  // auth dialog
  'auth.dialog.header': '身分驗證',
  'auth.dialog.please_select': '請選擇您的帳號提供商以登入。',
  'auth.dialog.redirecting_to': (provider) => `正在重新導向至 ${provider}...`,
  'auth.dialog.remember_me': '記住我',
  'auth.dialog.log_in': '登入',
  'auth.dialog.back': '返回',
  'auth.dialog.progress_header': '驗證中...',
  'auth.dialog.error.header': '驗證錯誤',
  'auth.dialog.error.auth_not_allowed': '使用者已禁止使用此憑證進行驗證。請使用其他憑證。',
  'auth.dialog.error.unknown': '無效的驗證參數。請重試。',
  'auth.dialog.error.back': '返回',

  'user.profile': '個人檔案',
  'user.logout': '登出',

  // deploy credential providers
  'deploy_credential_provider.steam': 'Steam',
  'deploy_credential_provider.itch': 'itch.io',

  'page_not_found.header': '找不到頁面',
  'page_not_found.message': '此頁面不存在。',
  'page_not_found.message2': '嗯，它可能曾經存在，但現在這裡什麼都沒有。以下是可能的原因：',
  'page_not_found.items': [
    '這裡以前有東西，但現在已被刪除。',
    '這裡仍有東西，但您沒有存取權限。',
    '或者只是有人在複製貼上連結時不夠小心。',
  ],

  'home': '首頁',
  'home.header.hint': '獨立開發者的雲端工具',
  'home.description': 'Kavykhi.Cloud 是一個專為獨立遊戲打造的開發平台。我們支援可下載與瀏覽器遊戲、私有與公開版本、分支、團隊等眾多功能。',
  'home.auth': '登入或註冊',
  'home.auth.hint': '建立新帳號或登入現有帳號',

  'projects': '專案',
  'projects.hint': '您正在參與的專案',
  'projects.project': (project) => `專案：${project}`,
  'projects.project.hint': '專案',
  'projects.no_projects': '您目前沒有任何專案。',
  'projects.new': '建立專案',
  'projects.new_dialog.header': '新專案',
  'projects.new_dialog.label': '專案名稱',
  'projects.new_dialog.ok': '建立專案',
  'projects.store_page': '公開商店頁面',
  'projects.description': '描述',
  'projects.branches': '分支',
  'projects.versions': '版本',
  'projects.packages': '套件',
  'projects.management': '專案設定',
  'projects.management.breadcrumb': '設定',
  'projects.management.title': (projectTitle) => `${projectTitle} - 設定`,
  'projects.management.hint': '專案設定',
  'projects.management.users': '團隊成員',
  'projects.management.users.empty': '無團隊成員。',
  'projects.management.users.role.tester': '測試員',
  'projects.management.users.role.developer': '開發者',
  'projects.management.users.role.admin': '管理員',
  'projects.management.users.role.owner': '擁有者',
  'projects.management.users.role.starred': '已星標',
  'projects.management.users.exile': '移出團隊',
  'projects.management.users.exile.dialog.header': '移出團隊',
  'projects.management.users.exile.dialog.message': (projectTitle, userTitle) => <>您確定要將 {userTitle} 從 {projectTitle} 專案中移除嗎？</>,
  'projects.management.users.exile.dialog.ok': '移出團隊',
  'projects.management.invites.one_time_invite': '一次性邀請連結',
  'projects.management.invites.one_time_invite.header': '一次性邀請連結',
  'projects.management.invites.one_time_invite.message': '一次性邀請連結：',
  'projects.management.invites.one_time_invite.note': '24 小時內有效，僅可使用一次。',
  'projects.management.invites.new_dialog.header': '邀請連結',
  'projects.management.invites.new_dialog.expires': '過期時間：',
  'projects.management.invites.new_dialog.expires.indefinite': '(永久有效)',
  'projects.management.invites.new_dialog.approval.label': '使用者加入專案：',
  'projects.management.invites.new_dialog.approval.not_approved': '需經管理員批准',
  'projects.management.invites.new_dialog.approval.approved': '立即加入',
  'projects.management.invites.new_dialog.seats': '限制加入人數：',
  'projects.management.invites.new_dialog.seats.no_limit': '(無限制)',
  'projects.management.invites.new_dialog.ok': '建立邀請連結',
  'projects.management.deploy_sites': '部署網站',
  'projects.management.deploy_sites.empty': '未新增部署網站。',
  'projects.management.deploy_sites.add': '新增部署網站',
  'projects.management.deploy_sites.delete': '刪除',
  'projects.management.deploy_sites.delete_dialog.header': '刪除部署網站',
  'projects.management.deploy_sites.delete_dialog.message': (provider, site) => <>您確定要刪除 {provider} 的部署網站 {site} 嗎？</>,
  'projects.management.deploy_sites.delete_dialog.ok': '刪除部署網站',
  'projects.management.public_access': '公開存取',
  'projects.management.public_access.enable': '啟用公開存取',
  'projects.management.public_access.enabled': <>公開存取：<strong>已允許</strong></>,
  'projects.management.public_access.enabled.note': '專案的名稱、描述以及任何標記為公開的分支都將公開。',
  'projects.management.public_access.enable_dialog.header': '啟用公開存取',
  'projects.management.public_access.enable_dialog.message': (projectTitle) => <>您確定要允許公開存取專案 {projectTitle} 嗎？<br /><br />這將使專案的基本資訊在未驗證的情況下也可見。您需要單獨為希望公開的每個分支啟用公開存取。</>,
  'projects.management.public_access.enable_dialog.ok': '啟用公開存取',
  'projects.management.public_access.disable': '停用公開存取',
  'projects.management.public_access.disabled': <>公開存取：<strong>不允許</strong></>,
  'projects.management.public_access.disabled.note': '此專案為私有。只有專案團隊的成員可以存取。',
  'projects.management.public_access.disable_dialog.header': '停用公開存取',
  'projects.management.public_access.disable_dialog.message': (projectTitle) => <>您確定要停用專案 {projectTitle} 的所有公開存取嗎？</>,
  'projects.management.public_access.disable_dialog.ok': '停用公開存取',
  'projects.management.public_access.branches': '公開分支',
  'projects.management.manage': '管理專案',
  'projects.rename': '重新命名專案',
  'projects.rename_dialog.header': '重新命名專案',
  'projects.rename_dialog.label': '專案名稱：',
  'projects.rename_dialog.ok': '重新命名專案',
  'projects.edit_description': '編輯專案描述',
  'projects.edit_description_dialog.header': '編輯專案描述',
  'projects.edit_description_dialog.label': '專案描述：',
  'projects.edit_description_dialog.ok': '編輯描述',
  'projects.leave': '離開專案',
  'projects.leave_dialog.header': '離開專案',
  'projects.leave_dialog.message': (projectTitle) => <>您確定要離開 {projectTitle} 專案嗎？</>,
  'projects.leave_dialog.ok': '離開專案',
  'projects.delete': '刪除專案',
  'projects.delete_dialog.header': '刪除專案',
  'projects.delete_dialog.message': (projectTitle) => <>您確定要刪除 {projectTitle} 專案嗎？</>,
  'projects.delete_dialog.ok': '刪除專案',

  'branches.header': (projectTitle, branchTitle) => `${projectTitle}: ${branchTitle}`,
  'branches.header.hint': '分支',
  'branches.no_branches': '此專案尚無分支',
  'branches.new': '建立分支',
  'branches.new_dialog.header': '新分支',
  'branches.new_dialog.label': '分支名稱',
  'branches.new_dialog.ok': '建立分支',
  'branches.current_version': (version) => <>目前版本：{version}</>,
  'branches.current_version.packages': '目前版本的套件',
  'branches.no_current_version': '無目前版本',
  'branches.publish_version.new': '發布新版本',
  'branches.publish_version.existing': '重新發布現有版本',
  'branches.version_history': '版本歷史紀錄',
  'branches.version_history.empty': '此分支的版本歷史紀錄為空。',
  'branches.version_history.note_removal': ({ quotaCount, quotaCountText, quotaNonCurrentTime, quotaTime }) => <>目前的分支版本將保留 {quotaTime != null ? <> {quotaTime}</> : <>永久</>}。先前的版本最多保留 {quotaNonCurrentTime}。每個分支最多保留 {plural(quotaCount, <>{quotaCountText} 個版本</>, <>{quotaCountText} 個版本</>)}。</>,
  'branches.manage': '管理分支',
  'branches.rename': '重新命名分支',
  'branches.rename_dialog.header': '重新命名分支',
  'branches.rename_dialog.label': '分支名稱：',
  'branches.rename_dialog.ok': '重新命名分支',
  'branches.delete': '刪除分支',
  'branches.delete_dialog.header': '刪除分支',
  'branches.delete_dialog.message': (branchTitle) => <>您確定要刪除 {branchTitle} 分支嗎？</>,
  'branches.delete_dialog.ok': '刪除分支',

  'versions.header': (projectTitle, versionTitle) => `${projectTitle} ${versionTitle}`,
  'versions.header.hint': '版本',
  'versions.current': '目前',
  'versions.previous': '上一個',
  'versions.description': '描述',
  'versions.deploy_to_site.header': '發布至網站',
  'versions.deploy_to_site': '發布至網站',
  'versions.packages': '套件',
  'versions.branches': '所在分支',
  'versions.branches.publish': '發布至分支',
  'versions.branches.empty': '此版本尚未發布至任何分支。',
  'versions.new_dialog.header': '新版本',
  'versions.new_dialog.label_title': '版本：',
  'versions.new_dialog.label_branch': '分支：',
  'versions.new_dialog.packages.header': '套件',
  'versions.new_dialog.packages.empty': '未新增套件。',
  'versions.new_dialog.packages.add': '新增套件',
  'versions.new_dialog.packages.add_existing': '新增先前上傳的套件',
  'versions.new_dialog.packages.replace': '替換套件',
  'versions.new_dialog.packages.edit': '編輯套件',
  'versions.new_dialog.ok': '建立版本',
  'versions.manage': '管理版本',
  'versions.rename': '重新命名版本',
  'versions.rename_dialog.header': '重新命名版本',
  'versions.rename_dialog.label': '版本名稱：',
  'versions.rename_dialog.ok': '重新命名版本',
  'versions.edit_description': '編輯版本描述',
  'versions.edit_description_dialog.header': '編輯版本描述',
  'versions.edit_description_dialog.label': '版本描述：',
  'versions.edit_description_dialog.ok': '編輯描述',
  'versions.delete': '刪除版本',
  'versions.delete_dialog.header': '刪除版本',
  'versions.delete_dialog.message': (versionTitle) => <>您確定要刪除版本 {versionTitle} 嗎？</>,
  'versions.delete_dialog.ok': '刪除版本',

  'versions.publish_dialog.header': '發布版本至分支',
  'versions.publish_dialog.message': (versionTitle) => <>選擇要將版本 {versionTitle} 發布至的分支。</>,
  'versions.publish_dialog.no_branches': '專案中無分支。',
  'versions.publish_dialog.ok': '發布版本',

  'versions.publish_existing_dialog.header': '重新發布版本',
  'versions.publish_existing_dialog.message': '最新版本：',
  'versions.publish_existing_dialog.no_versions': '專案中無版本。',
  'versions.publish_existing_dialog.ok': '發布版本',

  'packages.header': (projectTitle, packageTitle) => `${projectTitle}: ${packageTitle}`,
  'packages.header.hint': '套件',
  'packages.download_zip': '下載為 ZIP',
  'packages.download_torrent': '下載 Torrent',
  'packages.total_size': (size) => <>總大小：{size}</>,
  'packages.manage': '管理套件',
  'packages.rename': '重新命名套件',
  'packages.rename_dialog.header': '重新命名套件',
  'packages.rename_dialog.label': '套件名稱：',
  'packages.rename_dialog.ok': '重新命名套件',
  'packages.edit_tags': '編輯套件標籤',
  'packages.edit_tags_dialog.header': '編輯套件標籤',
  'packages.edit_tags_dialog.message': (packageTitle) => <>指定套件 {packageTitle} 的標籤：</>,
  'packages.edit_tags_dialog.ok': '設定套件標籤',
  'packages.entrypoint': (entrypoint) => <>啟動檔案：{entrypoint}</>,
  'packages.entrypoint.empty': '未設定啟動檔案。',
  'packages.delete': '刪除套件',
  'packages.delete_dialog.header': '刪除套件',
  'packages.delete_dialog.message': (packageTitle) => <>您確定要刪除套件 {packageTitle} 嗎？該套件將從所有已加入的版本中刪除。</>,
  'packages.delete_dialog.ok': '刪除套件',

  'packages.new_dialog.header': '新套件',
  'packages.new_dialog.label_title': '標題：',
  'packages.new_dialog.title_placeholder': '(來自標籤)',
  'packages.new_dialog.tags.header': '標籤',
  'packages.new_dialog.files.header': '檔案',
  'packages.new_dialog.total_size': (size, maximum) => <>總大小：{size} {maximum}</>,
  'packages.new_dialog.total_size.maximum': (size) => <>(最大 {size})</>,
  'packages.new_dialog.new_data_size': (size) => <>新資料大小：{size}</>,
  'packages.new_dialog.checks.empty': '未新增檔案。',
  'packages.new_dialog.checks.entrypoint.empty': '未設定啟動檔案。',
  'packages.new_dialog.checks.entrypoint.missing': (entrypoint) => <>啟動檔案 {entrypoint} 不存在；也許您忘記新增它？請指定現有的啟動檔案，或者您也可以不設定啟動檔案。</>,
  'packages.new_dialog.checks.entrypoint.missing.action': '取消設定啟動檔案',
  'packages.new_dialog.checks.entrypoint.ext.tag': (fileExt, tag) => <>啟動檔案的副檔名為 {fileExt}：建議使用 {tag} 標籤。</>,
  'packages.new_dialog.checks.entrypoint.ext.tag.action': (tag) => <>新增 {tag} 標籤</>,
  'packages.new_dialog.checks.entrypoint.ext.html': (fileExt, tag) => <>啟動檔案的副檔名為 {fileExt}：新增 {tag} 標籤以使套件可在瀏覽器中遊玩。</>,
  'packages.new_dialog.checks.entrypoint.ext.wrong': (fileExt) => <>啟動檔案的副檔名為 {fileExt}：這是否為錯誤？通常這不是可以啟動的檔案類型。</>,
  'packages.new_dialog.checks.entrypoint.ext.archive': (fileExt) => <>啟動檔案的副檔名為 {fileExt}：建議包含實際的內容檔案，而不是將它們打包成壓縮檔。</>,
  'packages.new_dialog.checks.entrypoint.executable': '啟動檔案未標記為可執行檔',
  'packages.new_dialog.checks.entrypoint.executable.action': '標記為可執行檔',
  'packages.new_dialog.checks.single_root_dir': '建議將檔案直接放在根目錄中，而不是在根目錄下只有單個資料夾。',
  'packages.new_dialog.checks.single_root_dir.action': '將資料夾替換為其內容',

  'packages.add_existing_dialog.header': '新增套件',
  'packages.add_existing_dialog.add': (packagesCount) => packagesCount > 0 ? `新增 ${plural(packagesCount, `${packagesCount} 個套件`, `${packagesCount} 個套件`)}` : '未選擇套件',
  'packages.add_existing_dialog.message': '最近上傳的套件：',
  'packages.add_existing_dialog.no_packages': '沒有最近上傳的套件。',

  'packages.launch': '啟動',

  'packages.install': '安裝',
  'packages.install_dialog.header': '安裝',
  'packages.install_dialog.workdir.label': '工作目錄：',
  'packages.install_dialog.workdir.value.new': '(建立新目錄)',
  'packages.install_dialog.workspace.label': '在此資料夾下建立：',
  'packages.install_dialog.workspace.placeholder': '(選擇根資料夾)',
  'packages.install_dialog.ok': '安裝',

  'packages.update': '更新',

  'packages.upload.status.existing': '來自上一個版本',
  'packages.upload.status.queued': '已排隊',
  'packages.upload.status.packing': '打包中...',
  'packages.upload.status.creating': '建立中...',
  'packages.upload.status.create_retrying': '建立失敗，正在等待並重試',
  'packages.upload.status.splitting': '分割中...',
  'packages.upload.status.uploading': '上傳中...',
  'packages.upload.status.finalizing': '完成中...',
  'packages.upload.status.finalize_retrying': '完成失敗，正在等待並重試',
  'packages.upload.status.resolving': '正在解析修補檔...',
  'packages.upload.status.resolve_retrying': '解析修補檔失敗，正在等待並重試...',
  'packages.upload.status.done': '上傳成功',
  'packages.upload.status.errored': '錯誤',

  'packages.upload.part.status.queued': '已排隊',
  'packages.upload.part.status.hashing': '雜湊中',
  'packages.upload.part.status.upload_queued': '上傳已排隊',
  'packages.upload.part.status.uploading': '上傳中',
  'packages.upload.part.status.upload_retrying': '錯誤，正在重試上傳',
  'packages.upload.part.status.upload_finalizing': '正在完成上傳',
  'packages.upload.part.status.upload_errored': '錯誤',
  'packages.upload.part.status.done': '已上傳',

  'packages.play': '在瀏覽器中遊玩',
  'packages.play.reset': '重設',
  'packages.play.fullscreen': '全螢幕',

  'deploy_sites.add_dialog.header': '新增部署網站',
  'deploy_sites.add_dialog.message': (projectTitle) => <>選擇部署憑證並輸入網站 URL，以將其儲存為專案 {projectTitle} 的部署網站。</>,
  'deploy_sites.add_dialog.label_credential': '部署憑證：',
  'deploy_sites.add_dialog.select_credential': '選擇憑證',
  'deploy_sites.add_dialog.select_credential.new': '新增憑證...',
  'deploy_sites.add_dialog.label_select_site': '選擇網站：',
  'deploy_sites.add_dialog.select_credential_first': '(請先選擇憑證)',
  'deploy_sites.add_dialog.select_site': '(選擇網站)',
  'deploy_sites.add_dialog.label_enter_site': '或輸入網站 URL：',
  'deploy_sites.add_dialog.ok': '新增網站',

  'deploy_to_site_dialog.header': '發布至網站',
  'deploy_to_site_dialog.message': (projectTitle, versionTitle) => <>選擇要發布 {projectTitle} 的版本 {versionTitle} 的網站。</>,
  'deploy_to_site_dialog.label_site': '發布至網站：',
  'deploy_to_site_dialog.select_site': '選擇網站',
  'deploy_to_site_dialog.select_site.new': '新增部署網站...',
  'deploy_to_site_dialog.packages.message.itch': <>套件將使用 <a href="https://itch.io/docs/butler/pushing.html" target="_blank">butler</a> 發布至 itch.io。頻道名稱衍生自套件標籤。</>,
  'deploy_to_site_dialog.deploy': '發布',
  'deploy_to_site_dialog.close': '關閉',
  'deploy_to_site_dialog.error.no_packages': '沒有可發布的套件。',
  'deploy_to_site_dialog.error.non_unique_channels': ({ packagesCount, packagesCountText, channel }) => <>多個套件無法發布到單個頻道。目前已設定將 {plural(packagesCount, <>{packagesCountText} 個套件</>, <>{packagesCountText} 個套件</>)} 發布到頻道 {channel}。</>,
  'deploy_to_site_dialog.job.queued': '已排隊',
  'deploy_to_site_dialog.job.downloading': '下載中...',
  'deploy_to_site_dialog.job.unpacking': '解包中...',
  'deploy_to_site_dialog.job.uploading': '發布中...',
  'deploy_to_site_dialog.job.succeeded': '成功',
  'deploy_to_site_dialog.job.errored': '錯誤',

  'store': '商店',
  'store.hint': '公開專案',
  'store.project.hint': '商店專案頁面',
  'store.project.owner': '開發者',
  'store.project.description': '描述',
  'store.project.star': '星標',
  'store.project.starred': '已星標',
  'store.project.content': '內容',
  'store.project.content.warning': '此內容由第三方開發者提供。',
  'store.project.branch_version': (branchTitle, versionTitle) => <>{branchTitle} 分支：版本 {versionTitle}</>,
  'store.project.branch_version.published': (branchVersionPublished) => <>發布時間：{branchVersionPublished}</>,

  'me': '個人檔案',
  'me.hint': '個人檔案設定與連結的憑證',
  'me.rename': '重新命名個人檔案',
  'me.rename_dialog.header': '重新命名個人檔案',
  'me.rename_dialog.label_title': '名稱：',
  'me.rename_dialog.ok': '重新命名個人檔案',
  'me.credentials': '憑證',
  'me.credentials.hint.auth_allowed': '這些憑證中的任何一個都可以用來登入此帳號。',
  'me.credentials.hint.auth_disallowed': '這些憑證已連結到您的帳號，但無法用於登入。',
  'me.credentials.empty': '無憑證。',
  'me.credentials.empty.auth_allowed.warning': '您可能會被鎖在帳號之外！您尚未連結任何可用於登入的憑證。請儘快連結一個您可以登入的憑證。',
  'me.credentials.profile_picture.alt': (provider) => `${dict[`auth.provider.${provider}`]} 個人檔案圖片`,
  'me.credentials.created': (created) => <>已於 {created} 新增</>,
  'me.credentials.last_used': (lastUsed) => <>上次使用於 {lastUsed}</>,
  'me.credential.unlink': '取消連結',
  'me.credential.allow_auth': '允許登入',
  'me.credential.disallow_auth': '不允許登入',
  'me.credential.display_publicly': '公開顯示',
  'me.credential.dont_display_publicly': '不公開顯示',
  'me.credential.link': '連結憑證',
  'me.credential.link_dialog.header': '連結憑證',
  'me.credential.link_dialog.message': '請選擇要連結的帳號提供商。',
  'me.credential.unlink_dialog.header': '取消連結憑證',
  'me.credential.unlink_dialog.are_you_sure': (credentialProvider, credentialTitle) => <>您確定要從您的 Kavykhi.Cloud 帳號中取消連結 {credentialProvider} 帳號 {credentialTitle} 嗎？</>,
  'me.credential.unlink_dialog.ok': '取消連結憑證',
  'me.sessions': '工作階段',
  'me.sessions.hint': '這是您活動中的工作階段列表，包括您目前的瀏覽器。',
  'me.sessions.started': (started) => <>開始於 <span class="value">{started}</span></>,
  'me.sessions.last_auth': (lastAuth) => <>活動於 <span class="value">{lastAuth}</span></>,
  'me.sessions.current': '目前工作階段',
  'me.sessions.empty': '無工作階段。',
  'me.sessions.delete': '終止',
  'me.sessions.delete_dialog.header': '終止工作階段',
  'me.sessions.delete_dialog.message': '您確定要終止此工作階段嗎？',
  'me.sessions.delete_dialog.ok': '終止工作階段',
  'me.api_tokens': 'API 權杖',
  'me.api_tokens.hint': '您可以在此處建立 API 權杖以用於自動化。',
  'me.api_tokens.started': (started) => <>建立於 <span class="value">{started}</span></>,
  'me.api_tokens.expires': (expires) => <>過期於 <span class="value">{expires}</span></>,
  'me.api_tokens.no_expiration': '永久有效',
  'me.api_tokens.empty': '無 API 權杖。',
  'me.api_tokens.create': '產生 API 權杖',
  'me.api_tokens.create_dialog.header': '產生 API 權杖',
  'me.api_tokens.create_dialog.message': '產生的 API 權杖：',
  'me.api_tokens.create_dialog.note': '此權杖將不會再次顯示，請妥善儲存。',
  'me.api_tokens.delete': '刪除',
  'me.api_tokens.delete_dialog.header': '刪除 API 權杖',
  'me.api_tokens.delete_dialog.message': '您確定要刪除此權杖嗎？',
  'me.api_tokens.delete_dialog.ok': '刪除 API 權杖',
  'me.deploy_credentials': '部署憑證',
  'me.deploy_credentials.hint': '您可以在此處新增用於部署到發布平台的憑證。',
  'me.deploy_credentials.empty': '未新增部署憑證。',
  'me.deploy_credential.add': '新增部署憑證',
  'me.deploy_credential.add_dialog.header': '新增部署憑證',
  'me.deploy_credential.add_dialog.label_site': '網站：',
  'me.deploy_credential.add_dialog.label_title': '備註：',
  'me.deploy_credential.add_dialog.label_key': '金鑰：',
  'me.deploy_credential.add_dialog.default_title': (date) => `金鑰 ${date}`,
  'me.deploy_credential.add_dialog.ok': '新增部署憑證',
  'me.deploy_credential.add_dialog.hint.itch': <>要產生 itch.io API 金鑰，請前往您在 itch.io 上的 <a href="https://itch.io/user/settings/api-keys" target="_blank">個人檔案設定</a>。您可以使用來源為 "web" 或 "wharf" 的現有 API 金鑰。來源為 "Kavykhi.Cloud" 的 API 金鑰將無法運作。</>,
  'me.deploy_credential.add_dialog.error.not_supported': (credentialProvider) => <>我們目前不支援新增 {credentialProvider} 憑證。</>,
  'me.deploy_credential.delete': '刪除',
  'me.deploy_credential.delete_dialog.header': '刪除部署憑證',
  'me.deploy_credential.delete_dialog.message': (credentialTitle, credentialProvider) => <>您確定要刪除 {credentialProvider} 的憑證 {credentialTitle} 嗎？使用此憑證設定的任何部署網站也將從專案中移除。</>,
  'me.deploy_credential.delete_dialog.ok': '刪除憑證',
  'me.public_profile': '公開個人檔案',
  'me.public_profile.public_credentials': '公開憑證',
  'me.public_profile.public_credentials.hint': '選擇要公開顯示的憑證。',
  'me.manage': '管理帳號',
  'me.delete': '刪除帳號',
  'me.delete.dialog.header': '刪除帳號',
  'me.delete.dialog.message': (userTitle) => <>您確定要永久刪除您的 Kavykhi.Cloud 帳號 {userTitle} 嗎？</>,
  'me.delete.dialog.ok': '刪除帳號',

  'invite': '邀請',
  'invite.hint': '專案邀請',
  'invite.message.already_member': (projectTitle) => <>您已經是專案 {projectTitle} 的成員。</>,
  'invite.message.join': (projectTitle) => <>您已被邀請加入專案 {projectTitle}。</>,
  'invite.join': '加入專案',

  'local': '本機內容',
  'local.hint': '本機安裝的內容',
  'local.workdirs': '已安裝的套件',
  'local.workdirs.empty': '無已安裝的套件。',
  'local.workdir.action.launch': '啟動',
  'local.workdir.action.repair': '修復',
  'local.workdir.action.delete': '解除安裝',
  'local.workdir.delete_dialog.header': '解除安裝套件',
  'local.workdir.delete_dialog.message': (packageTitle) => <>您確定要從您的裝置上解除安裝 {packageTitle} 套件嗎？</>,
  'local.workdir.delete_dialog.ok': '解除安裝',
  'local.workspaces': '根資料夾',
  'local.app_not_detected.message': '未偵測到 Kavykhi.Cloud 本機應用程式。請使用下方的連結下載並安裝。如果您已經安裝，請確保它正在執行。',

  'local_app.detected': '本機內容',

  'error_dialog.header': '錯誤',
  'error_dialog.messageFunc': (e) => `錯誤：${dict[`error.${e}`] ?? e}。`,

  'upload_box.choose_files': '選擇檔案',
  'upload_box.choose_directories': '選擇資料夾',
  'upload_box.add.progress_dialog.header': '正在新增檔案',
  'upload_box.add.progress_dialog.message': '正在處理檔案...',
  'upload_box.delete': (itemsCount) => `刪除 ${plural(itemsCount, `${itemsCount} 個項目`, `${itemsCount} 個項目`)}`,
  'upload_box.start_upload': '開始上傳',
  'upload_box.drop_area.message': '將檔案和資料夾拖放到此處',
  'upload_box.drop_area.box_dropping_message': '拖放到此處以放入根目錄',
  'upload_box.entry.explode_folder': '將資料夾替換為其內容',
  'upload_box.entry.set_entrypoint': '設定啟動檔案',
  'upload_box.entry.mark_executable': '標記為可執行檔',
  'upload_box.entry.unmark_executable': '取消標記為可執行檔',
  'upload_box.entry.remove': '移除',

  'package.tags.empty': '(無標籤)',
  'package.tag.os': '作業系統',
  'package.tag.os:windows': 'Windows',
  'package.tag.os:linux': 'Linux',
  'package.tag.os:macos': 'macOS',
  'package.tag.os:android': 'Android',
  'package.tag.os:ios': 'iOS',
  'package.tag.os:web': 'Web',
  'package.tag.arch': '架構',
  'package.tag.arch:x86': 'x86',
  'package.tag.arch:arm': 'ARM',
  'package.tag.bits': '位元',
  'package.tag.bits:64': '64 位元',
  'package.tag.bits:32': '32 位元',
  'package.tag.packaging': '打包方式',
  'package.tag.packaging:installer': '安裝程式',
  'package.tag.packaging:deb': '.deb',
  'package.tag.packaging:rpm': '.rpm',
  'package.tag.packaging:flatpak': 'Flatpak',
  'package.tag.component': '組件',
  'package.tag.component:client': '用戶端',
  'package.tag.component:server': '伺服器端',
  'package.tag.runtime': '執行環境',
  'package.tag.runtime:nodejs': 'Node.js',
  'package.tag.runtime:java': 'Java',
  'package.tag.distro': 'Linux 發行版',
  'package.tag.distro:ubuntu': 'Ubuntu',
  'package.tag.distro:fedora': 'Fedora',
  'package.tag.distro:arch': 'Arch Linux',
  'package.tag.distro:nixos': 'NixOS',

  'docs': '文件',
  'docs.page_no_language': '此語言版本不可用',
  'docs.page_no_language.message': '此文件的其他語言版本：',
  'docs.page_no_language.other_link': (doc, lang) => <>({lang}) {doc}</>,

  'social_links.discord': 'Discord',

  'report_content': '檢舉內容',
  'report_content.dialog.header': '檢舉內容',
  'report_content.dialog.link': '透過電子郵件傳送檢舉',
  'report_content.dialog.message': (email, link) => <>請點擊連結傳送您的檢舉：<br /><br />{link}<br /><br />或手動傳送電子郵件至 {email}</>,
};

export default dict;

const plural = (n: number, one: string, many: string) => n == 1 ? one : many;
